import { render, staticRenderFns } from "./StudySetup.vue?vue&type=template&id=0086d2de&scoped=true&"
import script from "./StudySetup.vue?vue&type=script&lang=js&"
export * from "./StudySetup.vue?vue&type=script&lang=js&"
import style0 from "./StudySetup.vue?vue&type=style&index=0&id=0086d2de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086d2de",
  null
  
)

export default component.exports